import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconCheck = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5 11.2857L7.2242 14.6935C7.6227 15.3041 8.51959 15.2967 8.90795 14.6796L15 5"
          stroke="currentColor"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconCheck.displayName = "IconCheck";

export { IconCheck };
